export default __webpack_public_path__ + "static/media/data-training.fd6f2faf.png";